import { render, staticRenderFns } from "./ShozokuSelectDialog.vue?vue&type=template&id=6812fa5f&scoped=true&"
import script from "./ShozokuSelectDialog.vue?vue&type=script&lang=ts&"
export * from "./ShozokuSelectDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShozokuSelectDialog.vue?vue&type=style&index=0&id=6812fa5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6812fa5f",
  null
  
)

export default component.exports